// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {createRegistrationsReview} from '../../shared/repositories';
import {getRegistrationsReviewReportCriteria} from '../../shared/services/reports';

export const createRegistrationsReviewReport = () =>
    async(dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        const registrationsReviewReport = getState().reports.registrationsReview;

        const reportCriteria = getRegistrationsReviewReportCriteria(registrationsReviewReport);

        try {

            const data = await createRegistrationsReview(reportCriteria);

            dispatch({
                data,
                type: actions.CREATE_REGISTRATIONS_REVIEW_REPORT_SUCCESS
            });

            dispatch({
                hasNoResult: data.length < 1,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } catch (error) {

            dispatch({
                hasNoResult: false,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/reports/registrations-review/action-creators/create-reports.js